.root {
  color: var(--mantine-color-anchor);
  text-decoration: none;
  appearance: none;
  border: none;
  display: inline;
  padding: 0;
  margin: 0;
  background-color: transparent;
  cursor: pointer;

  &:where([data-underline='hover']) {
    @mixin hover {
      text-decoration: underline;
    }
  }

  &:where([data-underline='not-hover']) {
    text-decoration: underline;

    @mixin hover {
      text-decoration: none;
    }
  }

  &:where([data-underline='always']) {
    text-decoration: underline;
  }

  &:where([data-variant='gradient']) {
    &,
    &:hover {
      text-decoration: none;
    }
  }

  &:where([data-line-clamp]) {
    display: -webkit-box;
  }
}
